var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseForm',{attrs:{"title":_vm.title,"routeKey":_vm.routeKey,"routes":_vm.routes,"form":_vm.form,"data":_vm.item,"update":_vm.updateItem,"create":_vm.createItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }